import { ApolloClient, HttpLink, type TypedDocumentNode } from '@apollo/client'
import { getApiUrl } from 'src/utils/config'
import { createApolloCache } from './client'

export type RouteApolloCacheEntry = {
  query: TypedDocumentNode<any, any>
  variables: Record<string, unknown>
  data: unknown
}

export function createRouteApolloClient(entries: RouteApolloCacheEntry[]) {
  const cache = createApolloCache()

  for (const entry of entries) {
    if (entry.data === undefined || entry.data === null) continue
    cache.writeQuery({
      query: entry.query,
      variables: entry.variables,
      data: entry.data,
    })
  }

  return new ApolloClient({
    ssrMode: typeof window === 'undefined',
    link: new HttpLink({
      uri: getApiUrl(),
      credentials: 'include',
    }),
    cache,
    defaultOptions: {
      query: {
        fetchPolicy: 'cache-first',
      },
      watchQuery: {
        fetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: false,
      },
    },
  })
}
